module.exports = __webpack_public_path__ + "static/img/2.feceda5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/2.png
// module id = p0zz
// module chunks = 0